import React from 'react';
import { Input } from '../../ui/input';
import CommonFormFields from './CommonFormFields';

/**
 * Local Delivery Form - Send items to another location
 */
const LocalDeliveryForm = ({ formData, setFormData }) => {
  const updateField = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  return (
    <div className="space-y-4">
      <CommonFormFields formData={formData} setFormData={setFormData} />
      
      <hr className="my-4" />
      <h4 className="font-bold text-lg">Pickup From You</h4>
      
      <div>
        <label className="block text-sm font-medium mb-2">Pickup Address *</label>
        <Input
          value={formData.pickup_address || ''}
          onChange={(e) => updateField('pickup_address', e.target.value)}
          placeholder="Your address"
          required
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium mb-2">Pickup Instructions</label>
        <Input
          value={formData.pickup_instructions || ''}
          onChange={(e) => updateField('pickup_instructions', e.target.value)}
          placeholder="Where to find the item, etc."
        />
      </div>
      
      <hr className="my-4" />
      <h4 className="font-bold text-lg">Item Details</h4>
      
      <div>
        <label className="block text-sm font-medium mb-2">Item Description *</label>
        <textarea
          value={formData.item_description || ''}
          onChange={(e) => updateField('item_description', e.target.value)}
          className="w-full p-3 border rounded-xl min-h-[80px]"
          placeholder="Describe what you're sending"
          required
        />
      </div>
      
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium mb-2">Quantity</label>
          <Input
            type="number"
            min="1"
            value={formData.item_quantity || 1}
            onChange={(e) => updateField('item_quantity', parseInt(e.target.value))}
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-2">Size</label>
          <select
            value={formData.item_size || 'medium'}
            onChange={(e) => updateField('item_size', e.target.value)}
            className="w-full p-3 border rounded-xl"
          >
            <option value="small">Small</option>
            <option value="medium">Medium</option>
            <option value="large">Large</option>
            <option value="oversized">Oversized (SUV)</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium mb-2">Declared Value ($)</label>
          <Input
            type="number"
            value={formData.declared_value || ''}
            onChange={(e) => updateField('declared_value', parseFloat(e.target.value))}
            placeholder="Optional"
          />
        </div>
      </div>
      
      <div className="flex flex-wrap gap-4">
        <label className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={formData.is_fragile || false}
            onChange={(e) => updateField('is_fragile', e.target.checked)}
            className="w-4 h-4"
          />
          Fragile
        </label>
        <label className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={formData.requires_signature || false}
            onChange={(e) => updateField('requires_signature', e.target.checked)}
            className="w-4 h-4"
          />
          Requires Signature
        </label>
        <label className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={formData.do_not_bend || false}
            onChange={(e) => updateField('do_not_bend', e.target.checked)}
            className="w-4 h-4"
          />
          Do Not Bend
        </label>
      </div>
      
      <hr className="my-4" />
      <h4 className="font-bold text-lg">Delivery Destination</h4>
      
      <div>
        <label className="block text-sm font-medium mb-2">Business Name (if applicable)</label>
        <Input
          value={formData.delivery_business_name || ''}
          onChange={(e) => updateField('delivery_business_name', e.target.value)}
          placeholder="Company or business name"
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium mb-2">Delivery Address *</label>
        <Input
          value={formData.delivery_address || ''}
          onChange={(e) => updateField('delivery_address', e.target.value)}
          placeholder="Full delivery address"
          required
        />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-2">Recipient Name *</label>
          <Input
            value={formData.delivery_contact_name || ''}
            onChange={(e) => updateField('delivery_contact_name', e.target.value)}
            placeholder="Who receives it"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-2">Recipient Phone *</label>
          <Input
            value={formData.delivery_contact_phone || ''}
            onChange={(e) => updateField('delivery_contact_phone', e.target.value)}
            placeholder="Recipient's phone"
            required
          />
        </div>
      </div>
    </div>
  );
};

export default LocalDeliveryForm;
